import React, {Component} from 'react'
import PropTypes from "prop-types";
import SvGraphics from "../../assets/SvGraphics";


class TreatmentPlan extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentEntry: this.props.current,
            titrationPlan: this.props.current.titrationPlan,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.currentEntry !== prevProps.currentEntry) {
            this.setState({
                currentEntry: this.props.currentEntry
            })
        }
    }

    componentDidMount() {
    }
    

    render() {
        let {currentEntry} = this.state
        let {t}=this.props
        let titrations = []
        let currentIndex=1
        let stepupEvery=currentEntry.TreatmentStepUpEvery?parseInt(currentEntry.TreatmentStepUpEvery)-1:2
        let titrationPlan=currentEntry.titrationPlan?currentEntry.titrationPlan:[]
        if(titrationPlan){
            for (let i = 0; i < 15; i++) {
                if(i < titrationPlan.length){
                    titrations.push(
                        <div className={"treatment-plan-box"}>
                            <div>
                                <label className={"treatment-plan-steps-label"}> {t('patient_boarding.Step')} {i + 1}</label>
                                <label className={"treatment-plan-steps-days-label"}> {t('patient_boarding.day')} {currentIndex}-{currentIndex+stepupEvery}</label>
                            </div>
                            <div>
                                <div className={"treatment-plan-icon-label"}>
                                    <div className={"treatment-plan-icon-back"}>
                                        <SvGraphics className={"treatment-plan-icon"} svgname={'morning-icon'}/>
                                    </div>
                                    <div className={"treatment-plan-box-arguments"}> {titrationPlan[i].M}</div>
                                </div>

                                <div className={"treatment-plan-icon-label"}>
                                    <div className={"treatment-plan-icon-back"}>
                                        <SvGraphics className={"treatment-plan-icon"} svgname={'noon-icon'}/>
                                    </div>
                                    <div className={"treatment-plan-box-arguments"}> {titrationPlan[i].N}</div>
                                </div>

                                <div className={"treatment-plan-icon-label"}>
                                    <div className={"treatment-plan-icon-back"}>
                                        <SvGraphics className={"treatment-plan-icon"} svgname={'evening-icon'}/>
                                    </div>
                                    <div className={"treatment-plan-box-arguments"}> {titrationPlan[i].E}</div>
                                </div>
                            </div>
                        </div>
                    )
                    currentIndex=currentIndex+stepupEvery+1
                }
            }
        }

        return (
            <div style={{display:this.props.view===6?'block':'none'}}>
                <div className={"treatment-plan-boxes-title"}>{t('patient_boarding.treatment_plan')}</div>
                <div className={"treatment-plan-boxes"}>
                    {titrations}
                </div>

            </div>

        )
    }
}

TreatmentPlan.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    currentEntry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default TreatmentPlan;
